const colors = require('tailwindcss/colors');

module.exports = {
    theme: {
        extend: {
            colors: {
                palette: {
                    green: '#27C60B',
                    blue: '#008BE4',
                    darkblue: '#002C4C',
                    lightblue: '#E0F6FC',
                },
                cyan: colors.cyan,
                violet: colors.violet,
            },
        },
        fontFamily: {
            inter: ['Inter', 'sans-serif'],
        },
    },

    plugins: [
        require('@tailwindcss/aspect-ratio'),
        require('@tailwindcss/typography'),
        require('@tailwindcss/line-clamp'),
        require('@tailwindcss/forms'),
    ],

    content: [
        __dirname + '/galaxy/modules/*/resources/**/*.{vue,js,scss,php}',
        __dirname + '/config/galaxy/common/*.{vue,js,scss,php}',
        __dirname + '/app/Modules/**/*.{vue,js,scss,php}',
        __dirname + '/resources/**/*.{vue,js,scss,php}',
    ],
};
